import { render, staticRenderFns } from "./EventLists.vue?vue&type=template&id=6db010c7&scoped=true"
import script from "./EventLists.vue?vue&type=script&lang=js"
export * from "./EventLists.vue?vue&type=script&lang=js"
import style0 from "./EventLists.vue?vue&type=style&index=0&id=6db010c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db010c7",
  null
  
)

export default component.exports